import Alpine from 'alpinejs'

function downloadBlob(blob, filename) {
    const link = document.createElement('a')
    const url = window.URL.createObjectURL(blob)
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
}

function formatCurrency(value) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value)
}

Alpine.data('pdfGenerationForm', (postUrl, metaUrl, projectId, pricePerTree, contributor) => ({
    isWorking: false,
    message: '',
    name: '',
    treeCount: 0,
    availableAmount: contributor.availableAmount,
    documentsGenerated: contributor.documentsGenerated,

    get donatedAmountFormatted() {
        return formatCurrency(contributor.amount)
    },

    get availableAmountFormatted() {
        return formatCurrency(this.availableAmount)
    },

    get totalFormatted() {
        return formatCurrency(this.treeCount * pricePerTree)
    },

    async getPreviewLink() {
        return fetch(postUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token: contributor.token,
                projectId: projectId,
                name: this.name,
                treeCount: parseInt(this.treeCount),
            }),
        })
    },

    async generatePdf(data) {
        const form = new FormData()
        form.append('paperHeight', '11.7')
        form.append('paperWidth', '8.27')
        form.append('marginTop', '0')
        form.append('marginRight', '0')
        form.append('marginBottom', '0')
        form.append('marginLeft', '0')
        form.append('landscape', 'false')
        form.append('printBackground', 'true')
        form.append('omitBackground', 'true')
        form.append('preferCssPageSize', 'true')
        form.append('url', data.url)

        return fetch(data.gotenbergApiUrl + '/forms/chromium/convert/url', {
            method: 'POST',
            headers: {
                'Gotenberg-Output-Filename': data.pdfFileName,
                'x-api-key': data.gotenbergApiKey,
                'Gotenberg-Trace': '',
            },
            body: form,
        })
    },

    async refreshMetaInfos() {
        try {
            const response = await fetch(metaUrl)
            if (response.ok) {
                const data = await response.json()
                this.availableAmount = data.availableAmount
                this.documentsGenerated = data.documentsGenerated
            }
        } catch {
            // silently fail — meta info refresh is non-critical
        }
    },

    resetForm() {
        this.name = ''
        this.treeCount = 0
        this.message = ''
        this.$root.querySelector('form')?.dispatchEvent(new Event('reset', { bubbles: true }))
    },

    async onSubmit() {
        this.$dispatch('validate')
        const invalids = this.$root.querySelectorAll('[data-validation-valid="false"]')
        if (invalids.length > 0) return

        this.isWorking = true
        this.message = ''

        try {
            const response = await this.getPreviewLink()
            if (response.ok) {
                const data = await response.json()
                const pdf = await this.generatePdf(data)
                if (pdf.ok) {
                    const blob = await pdf.blob()
                    downloadBlob(blob, data.pdfFileName)
                    this.resetForm()
                } else {
                    this.message = 'PDF konnte nicht erstellt werden. Bitte versuchen Sie es erneut.'
                }
            } else {
                const json = await response.json()
                this.message = json.message
            }
        } catch {
            this.message = 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
        }

        await this.refreshMetaInfos()
        this.isWorking = false
    },
}))
